// Site Configuration
export const SITE_CONFIG = {
  NAME: process.env.REACT_APP_SITE_NAME || 'mecenaso.pl',
  DESCRIPTION: process.env.REACT_APP_SITE_DESCRIPTION || 'Mecenaso.pl - profesjonalna pomoc prawna',
  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || 'http://mecenaso.pl',
} as const;

// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://api-panel.mecenaso.pl',
} as const;

// Polling intervals (in milliseconds)
export const POLLING_INTERVALS = {
  UNREAD_MESSAGES: 30000, // 30 seconds
  SESSION_CHECK: 60000, // 1 minute
} as const;

// LocalStorage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  AUTH_TOKEN_EXPIRY: 'auth_token_expiry',
  PENDING_LAWSUIT_FORM: 'pending_lawsuit_form',
  PENDING_LAWSUIT_STEP: 'pending_lawsuit_step',
} as const;

// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/api/client/auth/login',
  REGISTER: '/api/client/register',
  ACTIVATE: '/api/client/auth/activate',
  RESEND_CODE: '/api/client/auth/resend-code',
  LOGOUT: '/api/client/auth/logout',
  ME: '/api/client/auth/me',
  PROFILE: '/api/client/auth/profile',
  PASSWORD: '/api/client/auth/password',
  PASSWORD_RESET: '/api/client/password-reset',
  
  // Messages
  THREADS: '/api/client/auth/messages/threads',
  
  // Orders
  ORDERS: '/api/client/auth/orders',
  ORDER_STATUS_DICTIONARY: '/api/order-status-dictionary',
  
  // Lawsuit
  LAWSUIT: '/api/client/auth/lawsuit/persist',

  // Documents
  DOCUMENTS_UPLOAD: '/api/client/auth/documents',

  // Payment (public)
  ORDER_PAYMENT_DETAILS: '/api/order-payment-details',
  REGISTER_PAYMENT: '/api/register-payment',
} as const;

// Documents upload (zgodnie z API: max 400 KB, jpg, jpeg, png, pdf)
export const DOCUMENTS_UPLOAD_CONFIG = {
  MAX_FILE_BYTES: 400 * 1024, // 400 KB
  ALLOWED_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.pdf'],
  ACCEPT: '.jpg,.jpeg,.png,.pdf',
} as const;

// Route paths
export const ROUTES = {
  HOME: '/',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  DASHBOARD: '/dashboard',
  DASHBOARD_EDIT_PROFILE: '/dashboard/edit-profile',
  DASHBOARD_MESSAGES: '/dashboard/messages',
  DASHBOARD_CHANGE_PASSWORD: '/dashboard/change-password',
  DASHBOARD_CREATE_LAWSUIT: '/dashboard/create-lawsuit',
  DASHBOARD_ORDERS: '/dashboard/orders',
  DASHBOARD_DOCUMENTS: '/dashboard/documents',
  CREATE_LAWSUIT: '/form/create-lawsuit',
  PAYMENT: '/payment',
} as const;

// Validation
export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 8,
  POSTAL_CODE_LENGTH: 6,
  ACCOUNT_NUMBER_LENGTH: 26,
  NIP_LENGTH: 10,
} as const;

// HTTP Status codes
export const HTTP_STATUS = {
  OK: 200,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
} as const;

/** Limit ponownego wysłania kodu aktywacji (sekundy) – zgodnie z API: 1 żądanie na 5 minut */
export const RESEND_ACTIVATION_COOLDOWN_SEC = 5 * 60;
